import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=5fe336e8&scoped=true"
import script from "./Controls.vue?vue&type=script&lang=ts"
export * from "./Controls.vue?vue&type=script&lang=ts"
import style0 from "./Controls.vue?vue&type=style&index=0&id=5fe336e8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe336e8",
  null
  
)

export default component.exports